module.exports = __webpack_public_path__ + "img/empty-transactions.624c281c.svg";